import authorizedAPIInstance from '@/api/authorizedAPI';
import type {
  TagMappingRequest,
  TagMappingResponse,
  TagMappingUpdateRequest,
} from '../utils/match-maker.types';
import { formatAPIError } from '@/utils/helpers';

export const postTagMapping = async (
  payload: TagMappingRequest
): Promise<TagMappingResponse> => {
  try {
    const { data } = await authorizedAPIInstance.post<TagMappingResponse>(
      '/api/tag-mapping',
      payload
    );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};

export const deleteTagMapping = async (tagMappingId: string): Promise<void> => {
  try {
    await authorizedAPIInstance.delete(`/api/tag-mapping/${tagMappingId}`);
  } catch (error) {
    throw formatAPIError(error);
  }
};

export const patchTagMapping = async (
  tagMappingId: string,
  payload: TagMappingUpdateRequest
): Promise<TagMappingResponse> => {
  try {
    const { data } = await authorizedAPIInstance.patch<TagMappingResponse>(
      `/api/tag-mapping/${tagMappingId}`,
      payload
    );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};
